
    import * as React from 'react';

    const Sort16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" fill="none" style={svgStyle}><path d="M4 0.8 L8 4.8 L7.2 5.6 L4.56 2.96 L4.56 14.72 L3.44 14.72 L3.44 2.96 L0.8 5.6 L0 4.8 L4 0.8" /><path d="M12 15.2 L16 11.2 L15.2 10.4 L12.56 13.04 L12.56 1.28 L11.44 1.28 L11.44 13.04 L8.8 10.4 L8 11.2 L12 15.2" /></svg>
        </div>
      );
    };

    Sort16.displayName = 'Sort16';

    export default Sort16;
  